import React from 'react'
import clsx from 'clsx'
import { DittoProvider } from '@ow/ditto-core'
import { Tab } from '@ow/comps'
import {
  DetailStoreProvider,
  TbViewProvider,
  useProjectStore,
  useFetchRemoteData,
} from '@vt/hooks'
import { pick } from 'lodash-es'
import styled from '@emotion/styled'
import { getQuery } from '@vt/utils'
import useAreaStore from '../areas/areaStore'
import Attribute from '../areas/attribute'
import List from '../areas/list'
import BindUser from '../areas/bindUsers'
import Create from '../areas/binding/createBind'
import { useTabVisible } from '../areas/hooks/tab'

import FieldBindEditor from './fieldBindEditor'
import Calculation from './Calculation'
import LogicSpecEditor from './logicSpecEditor'
// import { BindProvider } from './BindProvider'

const StyledTab = styled(Tab)`
  height: 100%;
  .rc-tabs-content {
    height: 100%;
  }
`

const Detail = function ({ title, type, refreshTree }) {
  const fetchRemoteData = useFetchRemoteData()
  const { appId } = useProjectStore((state) => pick(state, ['appId']))
  const { vid } = getQuery()

  const { isCreateAreaBind } = useAreaStore((state) =>
    pick(state, ['isCreateAreaBind'])
  )

  const { tabRender, clickedId, areaBindUserTbId } = useTabVisible(title)

  return (
    <div className="flex flex-col gap-2 relative h-full">
      {isCreateAreaBind && <Create desc="指标" />}
      <div
        className={clsx('p-4 h-full bg-white', isCreateAreaBind && 'hidden')}
      >
        <StyledTab active="list" className="h-full" destroyInactiveTabPane>
          {tabRender(
            'attribute',
            <DittoProvider tbId={type} onFetchRemoteData={fetchRemoteData}>
              <DetailStoreProvider>
                <Attribute title={title} clickedId={clickedId} type={type} />
              </DetailStoreProvider>
            </DittoProvider>
          )}
          {tabRender(
            'list',
            <DittoProvider tbId={type} onFetchRemoteData={fetchRemoteData}>
              <TbViewProvider appId={appId} tbId={type} vid={vid}>
                <List clickedId={clickedId} refreshTree={refreshTree} />
              </TbViewProvider>
            </DittoProvider>
          )}
          {tabRender('user', <BindUser areaBindUserTbId={areaBindUserTbId} />)}
          {tabRender('ref', <FieldBindEditor />)}
          {tabRender('cal', <Calculation />)}
          {tabRender(
            'logicSpec',
            <DittoProvider tbId={type} onFetchRemoteData={fetchRemoteData}>
              <LogicSpecEditor />
            </DittoProvider>
          )}
        </StyledTab>
      </div>
    </div>
  )
}

export default Detail
